import { render, staticRenderFns } from "./SpecificationTable.vue?vue&type=template&id=f82a6d6e&scoped=true"
import script from "./SpecificationTable.vue?vue&type=script&lang=js"
export * from "./SpecificationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82a6d6e",
  null
  
)

export default component.exports